module.exports = __webpack_public_path__ + "static/media/Wolf912_1c.1feaa329.svg";